import React from 'react';
import { CARD_HEIGHT } from '../../bracketLayout';
import { cardY, STUB_LENGTH } from './geometry';
import styles from './BracketCanvas.module.scss';

// Líneas horizontales que representan conexiones desde la ronda anterior
export const buildStubs = (round, ei, color) => {
  const fin = round.id === 'final';
  return (
    <svg
      className={styles['bracket-canvas__stubs']}
      style={{
        position: 'absolute',
        top: 0,
        left: -STUB_LENGTH,
        width: STUB_LENGTH,
        height: '100%',
        overflow: 'visible',
        pointerEvents: 'none',
      }}
    >
      {round.matches.map((m, mi) => {
        const cy = cardY(ei, mi, fin) + CARD_HEIGHT / 2;
        return (
          <line
            key={m.id}
            x1={0}
            y1={cy}
            x2={STUB_LENGTH}
            y2={cy}
            stroke={color}
            strokeWidth="1"
          />
        );
      })}
    </svg>
  );
};
